import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledCode = /*#__PURE__*/styled('code').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1djvj5w-0"
})(["", ""], ({
  theme,
  $size,
  $scrollX
}) => css(["background-color:", ";border:", ";border-radius:", ";color:", ";font:", ";padding:0 ", ";margin:0;", " ", ""], theme.surface.subtleOffset, theme.border.subtle.default, theme.border.radius.medium, theme.text.color.default, theme.font.mono[$size].default, theme.spacing.xxsmall.default, $scrollX && 'overflow-x: auto;', isMobile(css(["font:", ";"], theme.font.mono[$size].mobile))));
StyledCode.displayName = 'StyledCode';
const Code = ({
  children,
  renderAs,
  size = 'base',
  ...rest
}) => {
  let scrollX = false;
  if (renderAs === 'pre') {
    scrollX = true;
  }
  return /*#__PURE__*/React__default.createElement(StyledCode, _extends({}, rest, {
    as: renderAs !== null && renderAs !== void 0 ? renderAs : 'code',
    $size: size,
    $scrollX: scrollX
  }), children);
};

export { Code as C };
//# sourceMappingURL=Code-C7SNOQzx.js.map
